import { render } from "./stock-transfer.vue?vue&type=template&id=07a9c290"
import script from "./stock-transfer.vue?vue&type=script&lang=js"
export * from "./stock-transfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__